module.exports = __webpack_public_path__ + "img/134.57d04bfe.png";